import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { startCase } from 'lodash';

const propTypes = {
  devices: PropTypes.array.isRequired,
};

const renderLabel = (label) => {
  if (!label) { return null; }
  return <small>({label})&nbsp;</small>;
};

const renderDevices = (devices = []) => {
  if (!devices.length) {
    return <div className="no-devices">No expiring devices.</div>;
  }

  return (
    <ul className="ExpiringDeviceList__list">
      {devices.map(device => (
        <li
          key={device.id}
          className="ExpiringDeviceList__item"
        >
          <Link
            to={`/account/devices/${device.id}/edit`}
            className="ExpiringDeviceList__link"
          >
            <div>
              <div className="device-name">
                {renderLabel(device.deviceable.label)}
                {device.manufacturer}
              </div>
              <div className="device-number">
                {startCase(device.deviceable.type)} / {device.deviceable.serial_number}
              </div>
            </div>

            <div className="expires-on">
              {moment(device.deviceable.calibration_date).format('L')}
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
};

const ExpiringDeviceList = ({ devices }) => (
  <div>
    <h3 className="section-title">Expiring Devices</h3>
    <Card className="ExpiringDeviceList minimal">
      <CardBody>
        {renderDevices(devices)}
      </CardBody>
    </Card>
  </div>
);

ExpiringDeviceList.propTypes = propTypes;

export default ExpiringDeviceList;



// WEBPACK FOOTER //
// ./src/features/dashboard/ExpiringDeviceList.js